/**
 * TanStack Query hooks for `real-time-link-coupon-interaction-monitoring-influ`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	realTimeLinkCouponInteractionMonitoringInfluQueryKeys,
	type CreateRealTimeLinkCouponInteractionMonitoringInfluBody,
	type ListRealTimeLinkCouponInteractionMonitoringInfluResponse,
	type RealTimeLinkCouponInteractionMonitoringInfluRow,
} from "./api";

export function useRealTimeLinkCouponInteractionMonitoringInfluList(): UseQueryResult<ListRealTimeLinkCouponInteractionMonitoringInfluResponse, Error> {
	return useQuery({
		queryKey: realTimeLinkCouponInteractionMonitoringInfluQueryKeys.list(),
		queryFn: list,
	});
}

export function useRealTimeLinkCouponInteractionMonitoringInfluCreate(): UseMutationResult<RealTimeLinkCouponInteractionMonitoringInfluRow, Error, CreateRealTimeLinkCouponInteractionMonitoringInfluBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: realTimeLinkCouponInteractionMonitoringInfluQueryKeys.all });
		},
	});
}

export function useRealTimeLinkCouponInteractionMonitoringInfluDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: realTimeLinkCouponInteractionMonitoringInfluQueryKeys.all });
		},
	});
}
